import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    mask: 'absolute inset-0 z-10 bg-black/30',
    imageContainer: 'absolute inset-0',
    picture: 'absolute inset-0',
    image: 'pointer-events-none object-cover',
    slide: 'group relative block w-full',
    link: 'absolute inset-0 z-30',
    container: 'container',
    content:
      'relative z-20 h-[320px] max-md:flex max-md:flex-col max-md:pt-3 max-md:pb-10 max-sm:h-[375px]',
    buttonsContainer: 'pointer-events-none absolute inset-0 max-md:hidden',
    buttons: 'absolute right-0 bottom-10 flex gap-8 max-lg:gap-6',
    title:
      'heading-3xl max-md:heading-2xl absolute bottom-10 left-0 line-clamp-2 w-[600px] text-white max-lg:w-[580px] max-md:static max-md:w-full max-md:pt-4',
    tagsContainer:
      'absolute top-10 left-0 z-40 flex max-md:static max-md:w-full max-md:grow',
    tag: 'data-[with-hover=true]:hover:text-main data-[with-hover=true]:hover:bg-bg-items-white px-3 tracking-[6%] transition-colors',
    withDoctor:
      'absolute right-0 bottom-[calc(50%+32px)] size-[112px] translate-y-[56px] max-md:static max-md:translate-y-0',
    carousel: '[--slide-size:100%]',
    button: 'pointer-events-auto static inset-auto block translate-0',
    dots: 'absolute bottom-3 left-4',
    activeDot: 'bg-white',
    videoPlay:
      'absolute top-1/2 left-1/2 z-20 flex -translate-x-1/2 -translate-y-1/2 items-center gap-5',
    videoIconWrap:
      'relative size-20 rounded-full backdrop-blur-[30px] backdrop-opacity-0 transition-all group-hover:bg-white/20 group-hover:backdrop-opacity-100',
    videoIcon:
      'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity group-hover:opacity-100',
    videoText:
      'heading-s-bold text-transparent uppercase transition-colors group-hover:text-white'
  },
  variants: {
    variant: {
      primary: {
        base: ''
      },
      secondary: {
        tag: 'text-main'
      }
    }
  },
  defaultVariants: {
    variant: 'primary'
  }
});
